module.exports = __webpack_public_path__ + "img/mariage-3.3347490e.jpg";